import { useEffect } from "react";
import { updatePageSEO } from "@/lib/seo";

const PrivacyPolicy = () => {
  useEffect(() => {
    updatePageSEO({
      title: "Privacy Policy | Diane Corso Fiction",
      description: "Privacy policy for www.dianecorsofiction.com — learn how we collect and protect your personal information.",
      canonical: "https://www.dianecorsofiction.com/privacy",
      ogImage: "https://www.dianecorsofiction.com/attached_assets/broken things book rev (1)_1756509124921.webp",
    });
  }, []);

  return (
    <div className="min-h-screen pt-16">
      <section className="py-20 bg-gothic-black">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-4xl font-cinzel font-bold text-blood-red mb-4">Privacy Policy</h1>
            <p className="text-gray-400">Last updated: {new Date().toLocaleDateString()}</p>
          </div>

          <div className="prose prose-lg max-w-none text-gray-300">
            <h2 className="text-2xl font-playfair font-bold text-gothic-white mb-4">Information We Collect</h2>
            <p className="mb-6">
              When you visit Diane Corso's website or subscribe to our newsletter, we may collect certain information about you, including:
            </p>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>Email address (when you subscribe to our newsletter)</li>
              <li>Name and contact information (when you submit contact forms)</li>
              <li>Usage data and analytics through cookies and similar technologies</li>
            </ul>

            <h2 className="text-2xl font-playfair font-bold text-gothic-white mb-4 mt-8">How We Use Your Information</h2>
            <p className="mb-6">
              We use the information we collect to:
            </p>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>Send you newsletter updates about new book releases and events</li>
              <li>Respond to your inquiries and contact form submissions</li>
              <li>Improve our website and user experience</li>
              <li>Comply with legal obligations</li>
            </ul>

            <h2 className="text-2xl font-playfair font-bold text-gothic-white mb-4 mt-8">Newsletter and Email Communications</h2>
            <p className="mb-6">
              If you subscribe to our newsletter, we will send you updates about Diane's writing, new releases, and events. You can unsubscribe at any time by clicking the unsubscribe link in any email or by contacting us directly.
            </p>

            <h2 className="text-2xl font-playfair font-bold text-gothic-white mb-4 mt-8">Data Sharing</h2>
            <p className="mb-6">
              We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except:
            </p>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>To trusted service providers who assist in operating our website</li>
              <li>When required by law or to protect our rights</li>
              <li>With your explicit consent</li>
            </ul>

            <h2 className="text-2xl font-playfair font-bold text-gothic-white mb-4 mt-8">Cookies and Tracking</h2>
            <p className="mb-6">
              Our website may use cookies and similar tracking technologies to enhance your experience. You can control cookie settings through your browser preferences.
            </p>

            <h2 className="text-2xl font-playfair font-bold text-gothic-white mb-4 mt-8">Your Rights</h2>
            <p className="mb-6">
              Depending on your location, you may have certain rights regarding your personal data, including:
            </p>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>The right to access your personal data</li>
              <li>The right to rectify inaccurate data</li>
              <li>The right to delete your personal data</li>
              <li>The right to object to or restrict processing</li>
            </ul>

            <h2 className="text-2xl font-playfair font-bold text-gothic-white mb-4 mt-8">Contact Us</h2>
            <p className="mb-6">
              If you have any questions about this Privacy Policy or our data practices, please contact us at:
            </p>
            <p className="mb-4">
              Email: privacy@dianecorso.com<br />
              Or use our <a href="/contact" className="text-blood-red hover:text-gothic-white">contact form</a>
            </p>

            <h2 className="text-2xl font-playfair font-bold text-gothic-white mb-4 mt-8">Changes to This Policy</h2>
            <p className="mb-6">
              We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
